import scope from "./scope";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "./selectors";
import SummaryType from "state/selections/Constants/SummaryType";
import { selectBaseGroupingParams } from "state/selections/selector";
import { exchange } from "@ls/js-fetch";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_DATA = `${scope}/REQUEST_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_DATA`;
export const requestScan2Data = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const absScan2CalcTypeSet = new Set(),
      absPercentilesSet = new Set(),
      relScan2CalcTypeSet = new Set(),
      relPercentilesSet = new Set();

    const scan2Definitions = selectDefinitions(SelectionState.COMMITTED)(state);

    scan2Definitions.forEach(({ scan2CalcType, percentiles, summary }) => {
      switch (summary) {
        case SummaryType.ABSOLUTE:
          absScan2CalcTypeSet.add(scan2CalcType);
          absPercentilesSet.add(percentiles);
          break;
        case SummaryType.RELATIVE:
          relScan2CalcTypeSet.add(scan2CalcType);
          relPercentilesSet.add(percentiles);
          break;
        default:
          throw new Error(`Unknown summary ${summary}`);
      }
    });

    if (absScan2CalcTypeSet.size) {
      dispatch(
        makeScan2Request(
          SummaryType.ABSOLUTE,
          [...absScan2CalcTypeSet],
          [...absPercentilesSet]
        )
      );
    }

    if (relScan2CalcTypeSet.size) {
      dispatch(
        makeScan2Request(
          SummaryType.RELATIVE,
          [...relScan2CalcTypeSet],
          [...relPercentilesSet]
        )
      );
    }
  };
};

const makeScan2Request = (summary, scan2CalcType, percentiles) => {
  return async (dispatch, getState) => {
    dispatch({ type: REQUEST_DATA, payload: { summary } });
    const state = getState();
    const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

    const [baseParams] = selectBaseGroupingParams(state);
    dispatch({
      type: RECEIVE_DATA,
      payload: {
        summary,
        data: (
          await exchange({
            params: {
              ...baseParams,
              summary,
              results: baseParams.results + ",VAR_GLOBAL,VAR",
              //results: ['VAR_GLOBAL', 'VAR'],
              var_types: [...new Set(scan2CalcType.map((calcType) => { return [...new Set(percentiles.map((percentile) => `${calcType}-${percentile}`))] }))],
              //var_percentiles: percentiles.join(","),
              //var_calc_types: scan2CalcType.join(","),
            },
            url,
            cancelId: `data-${scope}-${summary}`,
          })
        )?.data,
      },
    });
  };
};
